import React, { useEffect } from "react";
import AllRoute from "./main-component/router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./sass/style.scss";

// Importe os scripts de terceiros aqui
import TagManager from "react-gtm-module";
import Clarity from "@microsoft/clarity";

function App() {
  // Este 'hook' executa o código uma vez, depois de o componente ser renderizado
  useEffect(() => {
    // Atrasamos a inicialização para não impactar o carregamento inicial da página
    const timeoutId = setTimeout(() => {
      // 1. Inicializa o Google Tag Manager (GTM)
      const tagManagerArgs = {
        gtmId: "GTM-P8MSMBHR",
      };
      if (tagManagerArgs.gtmId) {
        TagManager.initialize(tagManagerArgs);
      }

      // 2. Inicializa o Microsoft Clarity
      const projectId = "t78fdxs2f3";
      if (projectId) {
        Clarity.init(projectId);
      }

      console.log("Scripts de Analytics (GTM, Clarity) carregados.");
    }, 2500); // Atraso de 2.5 segundos (pode ajustar)

    // Limpa o timeout se o utilizador sair da página antes do tempo
    return () => clearTimeout(timeoutId);
  }, []); // O array vazio [] garante que este código só executa uma vez

  // O conteúdo da sua aplicação continua aqui
  return (
    <div className="App" id="scrool">
      <AllRoute />
      <ToastContainer />
    </div>
  );
}

export default App;
